import useVoiceVisualizer from '@jobseeker/lotus/components/MediaRecorder/AudioRecorder/useVoiceVisualizer';
import {
  IconContainer,
  RecordingOverlay,
} from '@jobseeker/lotus/components/MediaRecorder/common';
import {Box, useTheme} from '@mui/material';
import {useEffect, useMemo, useState} from 'react';
import {FaPause, FaPlay} from 'react-icons/fa';
import {VoiceVisualizer} from 'react-voice-visualizer';

import {useIsLargeDevice} from '@jobseeker/lotus/hooks';

export const AudioPlayer = ({url}: {url: string}) => {
  const [isPlaying, setPlaying] = useState(false);

  const setAudioPlaying = () => {
    setPlaying(true);
  };
  const isLarge = useIsLargeDevice();
  const setAudioStop = () => {
    setPlaying(false);
  };
  const recorderControls = useVoiceVisualizer({
    onStartAudioPlayback: setAudioPlaying,
    onResumedAudioPlayback: setAudioPlaying,
    onEndAudioPlayback: setAudioStop,
    onPausedAudioPlayback: setAudioStop,
  });
  const theme = useTheme();

  const {
    audioRef,
    recordedBlob,
    duration,
    // formattedDuration,
    formattedRecordingTime,
    currentAudioTime,
    isRecordingInProgress,
    setPreloadedAudioBlob,
    clearCanvas,
    stopRecording,
    startRecording,
    error,
    togglePauseResume,
  } = recorderControls;

  const setAudioBlob = async () => {
    const audioResp = await fetch(url);
    const blob = await audioResp.blob();
    setPreloadedAudioBlob(new Blob([blob], {type: 'audio/mp3'}));
  };

  const durationToformattedDuration = (_duration: number) => {
    let seconds = Math.floor(_duration);
    const minutes = Math.floor(seconds / 60);
    if (minutes > 0) {
      seconds = seconds - minutes * 60;
    }
    return `${(minutes > 9 ? '' : '0') + minutes}:${
      (seconds > 9 ? '' : '0') + seconds
    }`;
  };
  const formattedDuration = useMemo(
    () => durationToformattedDuration(duration + 1),
    [duration]
  );
  const formattedAudioTime = useMemo(
    () => durationToformattedDuration(currentAudioTime),
    [currentAudioTime]
  );

  useEffect(() => {
    if (url) {
      setAudioBlob();
    }
  }, [url]);
  return (
    <Box
      sx={{
        borderRadius: 3,
        border: '1px solid #7E7E7E33',
        width: '100%',
        // height: '100%',
        // backgroundColor: 'gray.dark',
        background: '#7E7E7E33',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <VoiceVisualizer
        // component={VoiceVisualizer
        height={isLarge ? 350 : 280}
        // width={'100%'}
        mainBarColor={theme.palette.gray.dark}
        secondaryBarColor={theme.palette.gray.dark}
        gap={2}
        speed={0.5}
        fullscreen={true}
        isControlPanelShown={false}
        isDownloadAudioButtonShown={false}
        isDefaultUIShown={false}
        controls={recorderControls}
      />

      <Box
        sx={{
          position: 'absolute',
          top: 0,
          height: '100%',
          bottom: 0,
          margin: 'auto',
          width: '100%',
          p: 2,
        }}
      >
        {recordedBlob && (
          <IconContainer className="playIcon" onClick={togglePauseResume}>
            {isPlaying ? <FaPause /> : <FaPlay />}
          </IconContainer>
        )}
        {/* <Box position={'relative'} width={'100%'} height={'100%'}>
          <Image src={audioWave} fill alt="" />
        </Box> */}
      </Box>

      {!!duration && (
        <RecordingOverlay
          lapsedDuration={formattedAudioTime}
          totalDuration={formattedDuration}
          isRecording={false}
        />
      )}
    </Box>
  );
};

export default AudioPlayer;
